import React, { useMemo } from "react";

import "./index.scss";
import { safeGet } from "src/shared/utils";
import DetailsModel from "src/shared/models/DetailsModel";
import Shimmer from "src/shared/components/CustomisedShimmer";
import ChartFallback from "src/shared/components/ChartFallback";

type DetailsProps = {
  data: Array<IObject<any>>;
  charts: DetailsModel;
  loading: boolean;
};

type DetailsCardConfig = {
  label: string;
  valueField: string;
  secondaryValueField?: string;
  percentage?: string;
  planPercentage?: string;
  progressField?: string;
  planProgressField?: string;
};
const DetailsScroller = (props: DetailsProps) => {
  const { charts, data, loading } = props;
  const barsConfig = useMemo(
    () => [
      {
        height: "1rem",
        width: "100%",
        repeatBar: 3,
        className: "eachShimmer",
      },
    ],
    []
  );
  return (
    <div className={`top-nav-details ${data.length === 2 ? "top-nav-details--two" : ""}`}>
      {(data as DetailsCardConfig[]).map((item) => (
        <div className="details-item" key={item.label}>
          {loading && <Shimmer barsConfig={barsConfig} className="Shimmer" />}
          <div className="details-item-label">{!loading && charts ? item.label : null}</div>
          {charts && !charts.successful && !loading ? (
            <div className="details-404">
              <ChartFallback />
            </div>
          ) : (
            <>
              <div className="details-item-value">{!loading ? safeGet(charts, item.valueField, null) : null}</div>

              {item.planPercentage && safeGet(charts, item.planPercentage) && (
                <div
                  className={`${
                    safeGet(charts, item.planProgressField || "planProgress") == safeGet(charts, "isPositive")
                      ? "card-chart-up"
                      : "card-chart-down"
                  } ${safeGet(charts, item.planProgressField || "planProgress") ? "up-arrow" : "down-arrow"}`}
                >
                  {loading ? null : charts && charts[item.planPercentage]}
                </div>
              )}
              <div
                className={
                  charts && item.percentage && charts[item.percentage] === ""
                    ? "card-chart-neutral"
                    : `${
                        safeGet(charts, item.progressField || "progress") == safeGet(charts, "isPositive")
                          ? "card-chart-up"
                          : "card-chart-down"
                      } ${safeGet(charts, item.progressField || "progress") ? "up-arrow" : "down-arrow"}`
                }
              >
                {loading ? null : charts && item.percentage ? charts[item.percentage] : null}
              </div>

              {item.secondaryValueField && safeGet(charts, item.secondaryValueField) ? (
                <div className="details-item-secondary-below">
                  {loading ? null : safeGet(charts, item.secondaryValueField, null)}
                </div>
              ) : null}
            </>
          )}
        </div>
      ))}
    </div>
  );
};
export default DetailsScroller;
